export const GET_FILTER_LIST_REQUEST = 'Get knowledge assist filter list request'
export const GET_FILTER_LIST_SUCCESS = 'Get knowledge assist filter list success'
export const GET_FILTER_LIST_FAILURE = 'Get knowledge assist filter list failure'

//考点树
export const GET_TREEDATE_LIST_REQUEST = 'Get knowledge tree data list request'
export const GET_TREEDATE_LIST_SUCCESS = 'Get knowledge tree data list success'
export const GET_TREEDATE_LIST_FAILURE = 'Get knowledge tree data list failure'

//知识点树
export const GET_TREEDATE_KNOW_LIST_REQUEST = 'Get knowledge tree data know list request'
export const GET_TREEDATE_KNOW_LIST_SUCCESS = 'Get knowledge tree data know list success'
export const GET_TREEDATE_KNOW_LIST_FAILURE = 'Get knowledge tree data know list failure'

export const SET_PROPS_EDITION_CURRENT = 'Set props edition current'
export const SET_PROPS_BOOK_CURRENT = 'Set props book current'
export const SET_PROPS_ASSIST_CURRENT = 'Set props assist current'


export const GET_EDITION_LIST_REQUEST = 'Get knowledge edition list request'
export const GET_EDITION_LIST_SUCCESS = 'Get knowledge edition list success'
export const GET_EDITION_LIST_FAILURE = 'Get knowledge edition list failure'

export const GET_BOOK_LIST_REQUEST = 'Get knowledge book list request'
export const GET_BOOK_LIST_SUCCESS = 'Get knowledge book list success'
export const GET_BOOK_LIST_FAILURE = 'Get knowledge book list failure'

export const GET_ASSIST_LIST_REQUEST = 'Get knowledge assist list request'
export const GET_ASSIST_LIST_SUCCESS = 'Get knowledge assist list success'
export const GET_ASSIST_LIST_FAILURE = 'Get knowledge assist list failure'


export const SET_PROPS_EDITION_LIST = 'Set props edition edition list'
export const SET_PROPS_BOOK_LIST = 'Set props edition book list'
export const SET_PROPS_ASSIST_LIST = 'Set props edition assist list'

//名称搜索 多教辅时 手动选择
export const HANDLE_EDITION = 'Handle edition'
export const HANDLE_ASSIST = 'Handle assist'
export const HANDLE_BOOK = 'Handle book'





// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/actionType.js